import React, { useEffect } from "react";
import useCoinStore from "../stores/coinStore";
import NameItCoin from "./NameItCoin";

const CoinBalance = ({ 
  showBuyButton = true, 
  onBuyClick = null,
  className = "",
  size = "normal" // "small", "normal", "large"
}) => {
  const { 
    coinBalance, 
    loading, 
    syncBalance, 
    isStale 
  } = useCoinStore();

  useEffect(() => {
    // Sync balance on component mount if data is stale
    if (isStale()) {
      syncBalance();
    }
  }, [syncBalance, isStale]);

  const getSizeClasses = () => {
    switch (size) {
      case "small":
        return "text-sm px-3 py-2";
      case "large":
        return "text-lg px-5 py-3";
      default:
        return "text-base px-4 py-2";
    }
  };

  const getCoinIconSize = () => {
    switch (size) {
      case "small":
        return "w-5 h-5";
      case "large":
        return "w-7 h-7";
      default:
        return "w-6 h-6";
    }
  };

  const getBuyButtonSize = () => {
    switch (size) {
      case "small":
        return "px-2 py-1 text-xs";
      case "large":
        return "px-4 py-2 text-base";
      default:
        return "px-3 py-2 text-sm";
    }
  };

  if (loading) {
    return (
      <div className={`inline-flex items-center bg-gray-100 border border-gray-200 rounded-lg ${getSizeClasses()} ${className}`}>
        <div className={`${getCoinIconSize()} bg-gray-300 rounded-full animate-pulse mr-2`}></div>
        <span className="text-gray-600">Loading...</span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center ${className}`}>
      {/* Coin Balance Display */}
      <div className={`bg-white border-2 border-gray-200 text-gray-800 font-semibold rounded-lg flex items-center shadow-sm hover:shadow-md transition-shadow ${getSizeClasses()}`}>
        {/* Coin Icon */}
        <NameItCoin size={size} className="mr-2" />
        
        {/* Balance */}
        <span className="whitespace-nowrap">{coinBalance.toLocaleString()}</span>
      </div>

      {/* Buy Button */}
      {showBuyButton && onBuyClick && (
        <button
          onClick={onBuyClick}
          className={`ml-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors shadow-sm hover:shadow-md ${getBuyButtonSize()}`}
        >
          {size === "small" ? "+" : "Buy"}
        </button>
      )}
    </div>
  );
};

export default CoinBalance;